import {Component, ViewContainerRef} from '@angular/core';
import {AuthService} from "./+auth/auth.service";

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  public title = 'app works!';

  public constructor(private viewContainerRef: ViewContainerRef, public auth: AuthService) {
      auth.handleAuthentication();
  }

}



// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/app.component.ts